import React from 'react';

const Error = () => {
    return (
        <div>
            <p>Error: Page Not Found!</p>
        </div>
    );
}
export default Error;